import React from "react";
import AboutSection from "../AboutPage/AboutSection";
import ProductList from "./ProductList";
import { dataTop } from "../DUMMYDATA/DUMMYDATA";
import { Link } from "react-router-dom";
import ImageSlider from "../AboutPage/ImageSlider";

const Product = () => {
  const scrollToCategory = (categoryId) => {
    const categoryElement = document.getElementById(categoryId);
    if (categoryElement) {
      window.scrollTo({
        top: categoryElement.offsetTop,
        behavior: "smooth",
      });
    }
  };
  const bg3 = "../images/bg/bg3.webp";

  return (
    <>
      <AboutSection data="PRODUCTS" backgroundImage={bg3} />
      <div className="flex lg:flex-row md:flex-row max-sm:flex-col w-full lg:px-[83px] justify-center my-5 bg-[#fff]">
        {dataTop.map((data) => (
          <div
            key={data.id}
            className="relative overflow-hidden h-auto px-8 py-3 "
          >
            <Link
              to={`#${data.title.toLowerCase()}`}
              onClick={() => scrollToCategory(data.title.toLowerCase())}
            >
              <img
                className="w-full h-full object-cover transition-transform transform scale-100 group-hover:scale-110 lg:rounded-full md:rounded-full sm:rounded-3xl"
                src={data.url}
                alt="product_img"
              />
              <div className="absolute bottom-[-3px] left-0 w-full text-center pb-3">
                <h3 className="text-secondary2 text-sm">{data.title}</h3>
              </div>{" "}
            </Link>
          </div>
        ))}
      </div>
      <ImageSlider />
      <div id="featured">
        <ProductList />
      </div>

    </>
  );
};

export default Product;
